import publicComplaintFA from './fa/fa.json'

const PublicComplaintMessages = {
  fa: { ...publicComplaintFA },
}

export default PublicComplaintMessages
